@if(infoUbicacion){
  <div  class="flex w-full flex-col">

      <button (click)="obtenerUbicacion()" class="flex justify-center items-center px-2 py-1 mb-2 bg-primary-600 text-white rounded-3xl w-full md:w-30 ">
        <mat-icon [svgIcon]="'heroicons_solid:map-pin'" class="text-white"></mat-icon> 
        Ubicación
      </button>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 w-full justify-start items-stretch">
        <div class="h-full">
          <div class="flex flex-row border border-gray-300 items-center justify-center">
            <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
              >DIRECCION</label>
            <input type="text" name="direccion" [(ngModel)]="infoUbicacion.direccion" id="direccion" class="w-9/12 pl-3 text-xs md:text-md">
          </div>

          <div class="flex flex-row border-b border-x border-gray-300 items-center justify-center">
            <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
              >LATITUD</label>
            <input type="text" name="latitud" id="latitud" [(ngModel)]="infoUbicacion.latitud" class="w-9/12 pl-3 text-xs md:text-md">
          </div>

          <div class="flex flex-row border-b border-x border-gray-300 items-center justify-center">
            <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
              >LONGITUD</label>
            <input type="text" name="longitud" id="longitud" [(ngModel)]="infoUbicacion.longitud" class="w-9/12 pl-3 text-xs md:text-md">
          </div>

          <div class="flex flex-row border-b border-x border-gray-300 items-center justify-center">
            <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold">
              DEPARTAMENTO
            </label>
            <input type="hidden" [(ngModel)]="infoUbicacion.departamento" name="departamento" id="departamento">

            <div class="w-9/12 px-3 text-xs md:text-md py-1">
              {{ infoUbicacion.departamento?.descripcion || 'Sin departamento' }}
            </div>
          </div>

          <div class="flex flex-row border-b border-x border-gray-300 items-center justify-center">
            <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold">
              MUNICIPIO
            </label>
            <input type="hidden" [(ngModel)]="infoUbicacion.municipio" name="municipio" id="municipio">

            <div class="w-9/12 px-3 truncate text-xs md:text-md py-1">
              {{ infoUbicacion.municipio?.descripcion || 'Sin municipio' }}
            </div>
          </div>

          <div class="flex flex-row border-b border-x border-gray-300 items-center justify-center">
            <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
              >ALDEA</label>
            <input type="text" name="aldea" id="aldea" [(ngModel)]="infoUbicacion.aldea" class="w-9/12 pl-3 text-xs md:text-md">
          </div>

          <div class="flex flex-row border-b border-x border-gray-300 items-center justify-center">
              <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
                  >ELEVACION</label>
              <input type="text" name="elevacion" id="elevacion" [(ngModel)]="infoUbicacion.elevacion" class="w-9/12 pl-3 text-xs md:text-md">
          </div>

          <div class="flex flex-row border-b border-x border-gray-300 items-center justify-center">
              <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
                  >U.T.M</label>
              <input type="text" name="utm" id="utm" [(ngModel)]="infoUbicacion.utm" class="w-9/12 pl-3 text-xs md:text-md">
          </div>

          <div class="flex flex-row border-b border-x border-gray-300 items-center justify-center">
              <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
                  >GTM</label>
              <input type="text" name="gtm" id="gtm" [(ngModel)]="infoUbicacion.gtm" class="w-9/12 pl-3 text-xs md:text-md">
          </div>

          <div class="flex flex-row border-b border-x border-gray-300 items-center justify-center">
              <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
                  >MAPA</label>
              <input type="text" name="mapa" id="mapa" [(ngModel)]="infoUbicacion.mapa" class="w-9/12 pl-3 text-xs md:text-md">
          </div>

          <div class="flex flex-row border-b border-x border-gray-300 items-center justify-center">
              <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
                  >GEODÉSICA</label>
              <input type="text" name="geodesica" id="geodesica" [(ngModel)]="infoUbicacion.geodesica" class="w-9/12 pl-3 text-xs md:text-md">
          </div>
        

          <div class="flex flex-row border border-gray-300 items-center justify-center mt-6">
            <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
              >CATASTRO</label>
            <input type="text" name="catastro" id="catastro" [(ngModel)]="infoUbicacion.catastro" class="w-9/12 pl-3 text-xs md:text-md">
          </div>

          <div class="flex flex-row border-b border-x border-gray-300 items-center justify-center">
            <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
              >FINCA</label>
            <input type="text" name="finca" id="finca" [(ngModel)]="infoUbicacion.finca" class="w-9/12 pl-3 text-xs md:text-md">
          </div>

          <div class="flex flex-row border-b border-x border-gray-300 items-center justify-center">
            <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
              >FOLIO</label>
            <input type="text" name="folio" id="folio" [(ngModel)]="infoUbicacion.folio" class="w-9/12 pl-3 text-xs md:text-md">
          </div>  

          <div class="flex flex-row border border-gray-300 items-center justify-center">
            <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
              >LIBRO</label>
            <input type="text" name="libro" id="libro" [(ngModel)]="infoUbicacion.libro" class="w-9/12 pl-3 text-xs md:text-md">
          </div> 
          
        </div>

        <div>
            <iframe class="w-full h-full"
              style="border:0;"
              [src]="mapaUrl"
              allowfullscreen
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
        </div>
      </div>

      <div class="mt-8 flex justify-start w-full ml-0 md:ml-0.5">
        <button mat-raised-button 
          class="w-full md:w-40 rounded-md font-bold h-12" 
          (click)="actualizarInformacion()">Guardar</button>
      </div>
      
  </div>
}